//TODO trabajar en un componente para visualizar errores de acuerdo al objeto que devuelve el backend y generico
import React from 'react';

const Error = () => {
  return <div>Oppsie something wrong happened</div>;
};

export default Error;
